import React from "react";
import { toast } from "react-toastify";
import ButtonComponent from "../../components/buttons/ButtonComponent";

interface ConfirmToastProps {
  message: string;
  onConfirm: () => void;
  closeToast?: () => void;
}

const ConfirmToast: React.FC<ConfirmToastProps> = ({
  message,
  onConfirm,
  closeToast,
}) => {
  const handleConfirm = async () => {
    await onConfirm();
    closeToast?.();
  };

  return (
    <div>
      <p>{message}</p>
      <ButtonComponent onClick={handleConfirm} title="Да" />
    </div>
  );
};

export default ConfirmToast;
